var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImmigrantId(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17,0H7C4.243,0,2,2.243,2,5v14c0,2.757,2.243,5,5,5h10c2.757,0,5-2.243,5-5V5c0-2.757-2.243-5-5-5Zm-4.977,4.171c.561,0,.87,2.265,.977,4.829h-1.954c.107-2.564,.416-4.829,.977-4.829Zm.977,6.829c-.107,2.564-.435,4.829-.977,4.829s-.87-2.265-.977-4.829h1.954Zm-4.438-5.882c.41-.291,.978,.055,.877,.548-.251,1.215-.351,2.473-.39,3.334h-2.935c.27-1.6,1.177-2.98,2.448-3.882Zm-2.448,5.882h2.935c.039,.861,.14,2.119,.39,3.334,.102,.493-.466,.839-.877,.548-1.271-.902-2.178-2.282-2.448-3.882Zm9.887,9H8c-.553,0-1-.448-1-1s.447-1,1-1h8c.553,0,1,.448,1,1s-.447,1-1,1Zm-.516-5.118c-.41,.291-.978-.055-.877-.548,.251-1.215,.351-2.473,.39-3.334h2.935c-.27,1.6-1.177,2.98-2.448,3.882Zm-.487-5.882c-.039-.861-.14-2.119-.39-3.334-.102-.493,.466-.839,.877-.548,1.271,.901,2.178,2.282,2.448,3.882h-2.935Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImmigrantId);
export default __webpack_public_path__ + "static/media/immigrantID.6bf4dadea8d3b6bbaed4dccb2193cc44.svg";
export { ForwardRef as ReactComponent };